import React from 'react';
import Logo from './Logo';

const LogoHeader = ({ modifiers = "" }) => (
	<div
		className={`rounded-t-[12px] sm:rounded-t-[32px] relative flex items-center justify-center py-4 px-3 sm:px-16 ${modifiers}`}
	>
		<Logo />
	</div>
);

export default LogoHeader;
